import script from "./GetGimSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./GetGimSingle.vue?vue&type=script&setup=true&lang=js"

import "./GetGimSingle.vue?vue&type=style&index=0&id=307ce91e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-307ce91e"]])

export default __exports__